import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import API from "../config/config";

const EmployeeProfile = () => {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {
      const token = localStorage.getItem("adminToken");
      try {
        const response = await axiosInstance.get(
          `${API.ADMIN.EMPLOYEE_PROFILE}/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setEmployee(response.data.data);
      } catch (err) {
        console.error("Error fetching employee:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployee();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600 text-lg">Loading profile...</p>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500 text-lg">Employee not found</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-start justify-center py-10">
      <div className="w-full max-w-3xl bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-8 border-b pb-4">
          Employee Profile
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ProfileRow label="Full Name" value={employee.fullName || "-"} />
          <ProfileRow label="Role" value={employee.role || "-"} />
          <ProfileRow label="Phone" value={employee.phone || "-"} />
          <ProfileRow label="Email" value={employee.email || "-"} />
          <ProfileRow
            label="City"
            value={employee.city || employee.assignedCity || "-"}
          />
          {employee.employeeCode && (
            <ProfileRow label="Employee Code" value={employee.employeeCode} />
          )}
          {employee.assignedTo && (
            <ProfileRow
              label="Reports To"
              value={`${employee.assignedTo.firstName || ""} ${
                employee.assignedTo.lastName || ""
              }`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const ProfileRow = ({ label, value }) => (
  <div className="flex flex-col">
    <label className="text-sm text-gray-500">{label}</label>
    <div className="mt-1 px-4 py-2 bg-gray-100 text-gray-800 font-medium rounded">
      {value}
    </div>
  </div>
);

export default EmployeeProfile;
